import { type AbTastyCampaign, type AbTastyCampaignId } from '@/lib/ab-tasty';

// campaign__variant
type ExperimentKey = `${AbTastyCampaignId}__${string}`;

const experimentFeatureToggles: Record<
  ExperimentKey,
  Record<string, boolean>
> = {
  '1137642__1': {
    'dynamic-thank-you': true,
  },
  '1204769__1': {
    'cookie-banner': false,
  },
  '1291520__1': {
    'dynamic-thank-you': true,
  },
  '1406861__1': {
    'pdp-hero-form': true,
  },
};

export const enableExperimentFeatures = (
  featureToggles: Record<string, boolean>,
  abTastyTests: AbTastyCampaign[]
): Record<string, boolean> =>
  abTastyTests.reduce(
    (toggles, campaign): Record<string, boolean> => {
      const { campaignId, variationId } = campaign;
      const experimentKey: ExperimentKey = `${campaignId}__${variationId}`;
      const campaignFeatures = experimentFeatureToggles[experimentKey];
      return { ...toggles, ...campaignFeatures };
    },
    { ...featureToggles }
  );
